import React, { useState } from "react";
import { Alert } from "antd";
import dayjs from "dayjs";

// Post-login FSSAI licence expiry alert, shown at the top of the panel.
// Data comes from app-config (`fssai_alert`), which the backend fills only
// when the depot's licence is expired or expires within the alert window.
//
// - Expiring: yellow warning with the pending days. The user can close it,
//   but it comes back on the next login / page reload.
// - Expired: red error, cannot be closed — it stays until the licence date
//   is renewed in the Depot master.
export default function FssaiExpiryBanner({ alert, depotName }) {
  const [dismissed, setDismissed] = useState(false);

  if (!alert || typeof alert.days_left !== "number") return null;

  const expired = alert.status === "expired" || alert.days_left < 0;
  if (!expired && dismissed) return null;

  const date = dayjs(alert.valid_till).format("DD MMM YYYY");
  const licence = alert.fssai_number ? ` (Licence No. ${alert.fssai_number})` : "";
  const depot = depotName ? ` for ${depotName}` : "";
  const d = Math.abs(alert.days_left);
  const dayWord = d === 1 ? "day" : "days";

  let message;
  if (expired) {
    message = `FSSAI licence EXPIRED${depot}${licence} on ${date} — ${d} ${dayWord} overdue. Please renew immediately.`;
  } else if (alert.days_left === 0) {
    message = `FSSAI licence${depot}${licence} expires TODAY (${date}). Please renew immediately.`;
  } else {
    message = `FSSAI licence${depot}${licence} expires on ${date} — ${alert.days_left} ${dayWord} pending. Please renew before expiry.`;
  }

  return (
    <Alert
      banner
      type={expired ? "error" : "warning"}
      showIcon
      message={<strong>{message}</strong>}
      closable={!expired}
      onClose={() => setDismissed(true)}
      role="alert"
      style={{ padding: "8px 24px" }}
    />
  );
}
